module.exports = __webpack_public_path__ + "img/RETRO_A1014.bb5b0267.png";